import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CLP, formatDateTime } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Coins, Loader2, Receipt, Mail } from "lucide-react";
import { FICHAS_EVENT } from "@/components/FichasWallet";

const PaymentRow = ({ p, onResend, sending }) => (
  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 p-4 border-t border-border" data-testid={`payment-row-${p.id}`}>
    <div className="flex-1 min-w-0">
      <p className="font-semibold flex items-center gap-1.5" data-testid={`payment-pack-${p.id}`}>
        {p.pack_name}<span className="inline-flex items-center gap-0.5 text-sm font-medium text-amber-700"><Coins className="w-3.5 h-3.5" />{p.fichas} ficha{p.fichas === 1 ? "" : "s"}</span>
      </p>
      <p className="text-xs text-muted-foreground">
        {p.paid_at ? formatDateTime(p.paid_at) : "—"} · Plataforma de pago{p.card_last4 ? ` · **** ${p.card_last4}` : ""}{p.buy_order ? ` · N° ${p.buy_order}` : ""}
      </p>
    </div>
    <div className="sm:text-right">
      <p className="font-display font-bold" data-testid={`payment-amount-${p.id}`}>{CLP(p.amount_clp)}</p>
      {p.iva_clp != null && <p className="text-[11px] text-muted-foreground">Neto {CLP(p.net_clp)} + IVA {CLP(p.iva_clp)}</p>}
    </div>
    <Button variant="outline" size="sm" className="sm:ml-2 shrink-0" disabled={sending} onClick={() => onResend(p.id)} data-testid={`payment-resend-${p.id}`}>
      {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Mail className="w-4 h-4 mr-1.5" />Reenviar comprobante</>}
    </Button>
  </div>
);

export function PaymentHistory() {
  const [list, setList] = useState(null);
  const [sending, setSending] = useState(null);
  const resend = async (id) => {
    setSending(id);
    try { const { data } = await api.post(`/business/fichas/orders/${id}/resend`); toast.success(`Comprobante reenviado a ${data.email}`); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setSending(null); }
  };
  useEffect(() => {
    const load = () => api.get("/business/fichas/orders").then((r) => setList(r.data)).catch(() => setList([]));
    load();
    window.addEventListener(FICHAS_EVENT, load);
    return () => window.removeEventListener(FICHAS_EVENT, load);
  }, []);
  return (
    <Card className="overflow-hidden" data-testid="payment-history">
      <div className="p-4">
        <h3 className="font-bold flex items-center gap-2"><Receipt className="w-5 h-5 text-primary" />Historial de pagos</h3>
        <p className="text-xs text-muted-foreground mt-1">Tus compras de Fichas pagadas en la plataforma de pago, con IVA incluido.</p>
      </div>
      {list === null ? <div className="p-6 grid place-items-center"><Loader2 className="w-5 h-5 animate-spin" /></div>
        : list.length === 0 ? <p className="p-4 border-t border-border text-sm text-muted-foreground" data-testid="payment-history-empty">Aún no has comprado fichas.</p>
        : list.map((p) => <PaymentRow key={p.id} p={p} onResend={resend} sending={sending === p.id} />)}
    </Card>
  );
}
